import React, { useCallback } from "react";
import Card from "./CardDrag";
import update from "immutability-helper";

export interface CardItem {
  id: string | number;
  text: React.ReactNode;
  isShow: boolean;
  className?: string;
  style?: React.CSSProperties;
  group?: string;
}

interface RenderListProps {
  data: CardItem[];
  setState: React.Dispatch<React.SetStateAction<CardItem[]>>;
}

const RenderList: React.FC<RenderListProps> = ({ data, setState }) => {
  const moveCard = useCallback(
    (dragIndex: number, hoverIndex: number) => {
      setState((prevState) =>
        update(prevState, {
          $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, prevState[dragIndex]],
          ],
        })
      );
    },
    [setState]
  );

  const visibleCards = data
    .map((card, index) => ({ card, index }))
    .filter(({ card }) => card.isShow);
  const renderedGroups = new Set<string>();

  return (
    <div className="flex flex-col items-center">
      {visibleCards.map(({ card, index }) => {
        if (!card.group) {
          return (
            <Card
              key={card.id}
              index={index}
              id={card.id}
              text={card.text}
              moveCard={moveCard}
              className={card.className}
              style={card.style}
            />
          );
        }

        if (renderedGroups.has(card.group)) return null;
        renderedGroups.add(card.group);
        const groupCards = visibleCards.filter(({ card: item }) => item.group === card.group);
        const isSplit = groupCards.length > 1;

        return (
          <div
            key={`group-${card.group}`}
            className={`flex w-full items-center ${isSplit ? "justify-between" : "justify-center"}`}
          >
            {groupCards.map(({ card: groupCard, index: groupIndex }) => (
              <Card
                key={groupCard.id}
                index={groupIndex}
                id={groupCard.id}
                text={groupCard.text}
                moveCard={moveCard}
                className={`${groupCard.className || ""} text-center ${isSplit ? "flex-1" : ""}`}
                style={groupCard.style}
              />
            ))}
          </div>
        );
      })}
    </div>
  );
};

export default RenderList;
